import isEqual from 'fast-deep-equal/es6/react';
import { useMemo, useRef } from 'react';

/**
 * A hook that returns a referentially stable value if it is deeply equal between re-renders.
 */
export function useReferentiallyStable<T>(value: T): T {
  const ref = useRef<T>(value);

  return useMemo(() => {
    if (isEqual(ref.current, value)) {
      return ref.current;
    }
    ref.current = value;
    return value;
  }, [value]);
}
